var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('div',[_c('h1',[_vm._v("Loading, one moment...")])]):_c('div',[_c('nav-bar',{staticStyle:{"position":"relative","z-index":"10"}}),_c('router-view',{staticStyle:{"position":"relative","z-index":"5"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }